import React from "react";
import { Field, Form } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { Switch } from "../../../components/inputs/Switch";
import { LoadingButton } from "../../../components/LoadingButton";
import { composeValidators, required, isNotNaivePath, noPathTraversal } from "../../../util/validators";
import { camelizeKeys } from "../../../util/helpers";

export const S3DirectoryForm = ({ handleAction, directory }) => {
  return (
    <Form onSubmit={handleAction} initialValues={camelizeKeys({ ...directory })}>
      {({ handleSubmit, submitting }) => {
        return (
          <>
            <Field component={TextInput} required validate={required} label="Bucket Name" name="bucketName" />
            <Field
              component={TextInput}
              required
              validate={composeValidators(required, isNotNaivePath, noPathTraversal)}
              label="Prefix"
              name="prefix"
            />
            <Field component={Switch} label="Enabled" name="enabled" />
            <Field component={Switch} label="Tilde Delimited File" name="tildeDelimitedFile" />
            <Field component={Switch} label="Keep File in Directory" name="keepFileInDirectory" />

            <Field component="input" type="hidden" name="dir_type" value="sweep" />

            <hr className="my-4" />
            <h5 className="text-muted">Advanced Options (Optional)</h5>

            <Field component={TextInput} label="Region (Optional)" name="s3Region" placeholder="Leave empty for default" />
            <Field
              component={TextInput}
              label="Endpoint (Optional)"
              name="s3Endpoint"
              placeholder="Endpoint URL, leave empty for default"
            />
            <Field
              component={TextInput}
              label="AWS Access Key (Optional)"
              name="s3AccessKeyId"
              placeholder="Access Key, leave empty for none"
            />
            <Field component={TextInput} label="AWS Secret Key (Optional)" type="password" name="s3SecretAccessKey" />
            <Field component={TextInput} label="Role ARN (Optional)" name="roleArn" placeholder="Leave empty for default internal access" />
            <Field
              component={TextInput}
              label="External ID (Optional)"
              name="externalId"
              placeholder="Required only for cross-account access"
            />

            <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
              Save
            </LoadingButton>
          </>
        );
      }}
    </Form>
  );
};
